import { Container, Grid, Card, CardContent, Typography, Button, Box } from '@mui/material';
import DiscountIcon from '@mui/icons-material/Discount';
import SecurityIcon from '@mui/icons-material/Security';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import { getImageUrl } from '../../utils';

const membershipsData = [
  {
    title: 'Månadskort',
    price: '650 kr/mån',
    description: 'Träna obegränsat på våra schemalagda klasser. 3 månaders bindningstid.',
  },
  {
    title: 'Månadskort Ungdom/Pensionär',
    price: '550 kr/mån',
    description: 'Obegränsad träning på våra klasser för ungdomar och pensionärer. 3 månaders bindningstid.',
  },
  {
    title: '10-Kort',
    price: '1250 kr',
    description: 'Träna 10 tillfällen på våra schemalagda klasser',
  },
];

const Memberships = () => (
  <Box sx={{ background: 'linear-gradient(to bottom, #ffffff, #fdfdfd)', py: { xs: 6, md: 8 } }}>
    <Container>
      <Typography
        variant="h3"
        align="center"
        sx={{
          fontFamily: 'var(--font-heading)',
          fontWeight: 700,
          color: '#222',
          fontSize: { xs: '2rem', md: '2.5rem' },
          mb: 6,
        }}
      >
        Vårt Utbud
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {membershipsData.map((membership, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                position: 'relative',
                overflow: 'hidden',
                background: 'rgba(255, 255, 255, 0.6)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                borderRadius: '1rem',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                p: 3,
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-6px)',
                  boxShadow: '0 12px 30px rgba(0, 0, 0, 0.15)',
                },
              }}
            >
              {/* Background Image */}
              <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  backgroundImage: `url(${getImageUrl('klasses-ball.png')})`, // <- Add your faded image
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  opacity: 0.111,
                  zIndex: 0,
                }}
              />

              <CardContent sx={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
                <Typography
                  variant="h5"
                  sx={{
                    color: '#00b5bf',
                    fontWeight: 900,
                    textTransform: 'uppercase',
                    fontSize: '1.5rem',
                    mb: 1,
                  }}
                >
                  {membership.title}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 'bold',
                    fontSize: '1.25rem',
                    color: '#333',
                    mb: 2,
                  }}
                >
                  {membership.price}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight:'bolder',
                    color: '#333',
                    fontSize: '1rem',
                    lineHeight: 1.6,
                  }}
                >
                  {membership.description}
                </Typography>
              </CardContent>

              <Box textAlign="center" mt={3} sx={{ position: 'relative', zIndex: 1 }}>
                <Button
                  variant="contained"
                  href="/sidepages/membership-info"
                  sx={{
                    background: 'linear-gradient(135deg, #00b5bf, #429398)',
                    color: '#fff',
                    px: 3,
                    py: 1,
                    borderRadius: '999px',
                    fontWeight: 600,
                    fontSize: '1rem',
                    textTransform: 'none',
                    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      background: 'linear-gradient(135deg, #007C85, #357f87)',
                    },
                  }}
                >
                  Se Mer
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Info section */}
      <Box sx={{ mt: 12, maxWidth: '800px', mx: 'auto' }}>
        {[
          {
            icon: <CardGiftcardIcon sx={{ color: '#00b5bf' }} />,
            text: 'Alla medlemskap är personliga och får inte delas med andra eller överlåtas till någon annan.',
          },
          {
            icon: <CardMembershipIcon sx={{ color: '#00b5bf' }} />,
            text: 'Frysning av medlemskort utan sjukintyg kostar 150 kr, och en avgift på 150 kr tillkommer vid återaktivering.',
          },
          {
            icon: <DiscountIcon sx={{ color: '#00b5bf' }} />,
            text: 'Visdomsrabatt ges till personer under 18 eller över 65 år.',
          },
          {
            icon: <SecurityIcon sx={{ color: '#00b5bf' }} />,
            text: 'Vi har 15-års åldersgräns i studion.',
          },
          
        ].map(({ icon, text }, idx) => (
          <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            {icon}
            <Typography
              variant="body2"
              sx={{
                ml: 2,
                fontStyle: 'italic',
                fontSize: '1rem',
                color: '#444',
              }}
            >
              {text}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Final CTA button */}
      <Box sx={{ textAlign: 'center', mt: 6 }}>
        <Button
          variant="contained"
          href="/sidepages/membership-info"
          sx={{
            background: 'linear-gradient(135deg, #00b5bf, #429398)',
            color: '#fff',
            px: 4,
            py: 1.25,
            fontSize: '1rem',
            borderRadius: '999px',
            fontWeight: 600,
            boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
            '&:hover': {
              background: 'linear-gradient(135deg, #007C85, #357f87)',
              transform: 'translateY(-2px)',
            },
          }}
        >
          Se Utbud
        </Button>
      </Box>
    </Container>
  </Box>
);

export default Memberships;
